import { render, staticRenderFns } from "./ParamAddSizeColor.vue?vue&type=template&id=be34399c"
import script from "./ParamAddSizeColor.vue?vue&type=script&lang=js"
export * from "./ParamAddSizeColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports